const API_BASE_URL = "/api";

const WS_BASE_URL = "";

const STATIC_BASE_URL = "";

export {
  API_BASE_URL,
  WS_BASE_URL,
  STATIC_BASE_URL
};

export default {
  API_BASE_URL,
  WS_BASE_URL,
  STATIC_BASE_URL
};


// admin-react\src\config\url.js
// export const API_BASE_URL = "http://localhost:8000/api";
// export const WS_BASE_URL = "ws://localhost:8000";
// export const STATIC_BASE_URL = "http://localhost:8000";
// export default {
//   API_BASE_URL,
//   WS_BASE_URL,
//   STATIC_BASE_URL  
// };
